"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHotelRateDiscountable = void 0;
const isHotelRateDiscountable = (data) => {
    // if any of the rates have a discount_id of null, return false
    for (let i = 0; i < data.length; i++) {
        if (!data[i].discount_id) {
            return false;
        }
    }
    return true;
};
exports.isHotelRateDiscountable = isHotelRateDiscountable;
